/* DR - scripts de la landing del dron */
(function () {
  if (window.__drInit) return;
  window.__drInit = true;

  /* boton que abre el formulario de pago contra entrega (Releasit) */
  window.rsiTrigger = function () {
    var sels = ['#rsi_buy_now_button', '#rsi-button-hook button', '#rsi-button-hook a',
      '._rsi-buy-now-button-app-block-hook button', 'button[id^="rsi"]', 'button[class*="rsi-"]'];
    for (var i = 0; i < sels.length; i++) {
      var b = document.querySelector(sels[i]);
      if (b) { b.click(); return; }
    }
    var h = document.getElementById('rsi-button-hook') || document.querySelector('[data-dr-ficha]');
    if (h && h.scrollIntoView) h.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn();
  }

  /* aparicion al hacer scroll */
  function initReveal() {
    var els = [].slice.call(document.querySelectorAll('.dr-rev:not([data-dr-visto])'));
    if (!els.length) return;
    function show(el) { el.classList.add('is-visible'); el.setAttribute('data-dr-visto', '1'); }
    if (!('IntersectionObserver' in window)) { els.forEach(show); return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { show(e.target); obs.unobserve(e.target); } });
    }, { threshold: 0, rootMargin: '0px 0px 0px 0px' });
    els.forEach(function (el) { obs.observe(el); });
    setTimeout(function () { els.forEach(show); }, 3000);
  }

  /* carruseles (testimonios) */
  function initCarruseles() {
    [].forEach.call(document.querySelectorAll('[data-dr-carrusel]:not([data-dr-listo])'), function (c) {
      c.setAttribute('data-dr-listo', '1');
      var slides = [].slice.call(c.querySelectorAll('[data-dr-slide]'));
      var dotsBox = c.querySelector('[data-dr-dots]');
      if (slides.length < 1) return;
      var claseDot = c.getAttribute('data-dot-clase') || 'dr-test__dot';
      var cur = 0, dots = [];
      if (dotsBox) {
        slides.forEach(function (_, i) {
          var d = document.createElement('button');
          d.type = 'button'; d.className = claseDot + (i === 0 ? ' is-on' : '');
          d.setAttribute('aria-label', 'Testimonio ' + (i + 1));
          d.addEventListener('click', function () { go(i); });
          dotsBox.appendChild(d); dots.push(d);
        });
      }
      function go(n) {
        slides[cur].classList.remove('is-on'); if (dots[cur]) dots[cur].classList.remove('is-on');
        cur = (n + slides.length) % slides.length;
        slides[cur].classList.add('is-on'); if (dots[cur]) dots[cur].classList.add('is-on');
      }
      var prev = c.querySelector('[data-dr-prev]'), next = c.querySelector('[data-dr-next]');
      if (prev) prev.addEventListener('click', function () { go(cur - 1); });
      if (next) next.addEventListener('click', function () { go(cur + 1); });
      if (slides.length > 1) setInterval(function () { go(cur + 1); }, 5000);
    });
  }

  /* preguntas frecuentes */
  document.addEventListener('click', function (e) {
    var q = e.target.closest && e.target.closest('[data-dr-faq-q]');
    if (!q) return;
    var item = q.closest('.dr-faq__item');
    var abierta = item.classList.contains('is-open');
    [].forEach.call(item.parentNode.querySelectorAll('.dr-faq__item'), function (i) { i.classList.remove('is-open'); });
    if (!abierta) item.classList.add('is-open');
  });

  /* galeria de la ficha */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-dr-thumb]');
    if (!t) return;
    var gal = t.closest('[data-dr-gal]');
    var main = gal && gal.querySelector('[data-dr-main]');
    if (!main) return;
    main.src = t.getAttribute('data-src');
    main.removeAttribute('srcset');
    [].forEach.call(gal.querySelectorAll('[data-dr-thumb]'), function (b) { b.classList.remove('is-on'); });
    t.classList.add('is-on');
  });

  /* selector de color: cambia la variante que lee el formulario de pago */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-dr-variante]');
    if (!b || b.disabled) return;
    var id = b.getAttribute('data-dr-variante');
    var caja = b.closest('[data-dr-color]');
    [].forEach.call(caja.querySelectorAll('[data-dr-variante]'), function (x) { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); });
    b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true');
    var nombre = caja.querySelector('[data-dr-color-nombre]');
    if (nombre) nombre.textContent = b.getAttribute('data-nombre');
    [].forEach.call(document.querySelectorAll('form[action*="/cart/add"] input[name="id"], input[data-dr-variante-input]'), function (inp) {
      inp.value = id;
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    });
    try {
      var url = new URL(window.location.href); url.searchParams.set('variant', id);
      window.history.replaceState({}, '', url.toString());
    } catch (err) {}
    document.dispatchEvent(new CustomEvent('variant:change', { detail: { variantId: id } }));
    var img = b.getAttribute('data-imagen'), main = document.querySelector('[data-dr-main]');
    if (img && main) { main.src = img; main.removeAttribute('srcset'); }
  });

  /* resumen de estrellas: promedio y cantidad de las opiniones reales */
  function initResumen() {
    var box = document.querySelector('[data-dr-resumen]');
    if (!box) return;
    var link = box.querySelector('[data-dr-ir-resenas]');
    if (!link) return;
    var slides = [].slice.call(document.querySelectorAll('.dr-test__s'));
    if (!slides.length) return;
    var sum = 0;
    slides.forEach(function (s) { sum += 5 - s.querySelectorAll('.dr-test__est-off').length; });
    var avg = sum / slides.length, n = slides.length;
    var pal = box.getAttribute('data-palabra') || 'reseñas';
    if (n === 1) pal = pal.replace(/s$/, '');
    box.querySelector('[data-dr-avg]').textContent = avg.toFixed(1).replace('.', ',');
    box.querySelector('[data-dr-n]').textContent = n;
    box.querySelector('[data-dr-pal]').textContent = pal;
    box.querySelector('[data-dr-fg]').style.width = (avg / 5 * 100) + '%';
    link.hidden = false;
    var sep = box.querySelector('[data-dr-sep]');
    if (sep && box.querySelector('.dr-rating__ventas')) sep.hidden = false;
  }

  onReady(function () { initReveal(); initCarruseles(); initResumen(); });
  document.addEventListener('shopify:section:load', function () { initReveal(); initCarruseles(); initResumen(); });
})();
